import { db } from "../firebase";
import {
  collection,
  doc,
  getDocs,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  serverTimestamp,
  Timestamp,
} from "firebase/firestore";

const COL = "ingresos";

// Convierte Date | string | Timestamp a Firestore Timestamp para guardar
function aTimestamp(valor) {
  if (!valor) return null;
  if (valor instanceof Timestamp) return valor;
  if (valor instanceof Date) return Timestamp.fromDate(valor);
  const d = new Date(valor);
  return isNaN(d.getTime()) ? null : Timestamp.fromDate(d);
}

export async function getIngresos() {
  const q = query(collection(db, COL), orderBy("fecha", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function getIngreso(id) {
  const ref = doc(db, COL, id);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
}

export async function crearIngreso(data) {
  const payload = {
    fecha: aTimestamp(data.fecha) || serverTimestamp(),
    concepto: data.concepto || "",
    cliente: data.cliente || "",
    colega: data.colega || "",
    categoria: data.categoria || "Otros",
    ingreso: Number(data.ingreso) || 0,
    aCuenta: Number(data.aCuenta) || 0,
    menos: Number(data.menos) || 0,
    total: Number(data.total) || 0,
    notas: data.notas || "",
    creadoEn: serverTimestamp(),
  };
  const ref = await addDoc(collection(db, COL), payload);
  return ref.id;
}

export async function actualizarIngreso(id, data) {
  const ref = doc(db, COL, id);
  const payload = {
    fecha: aTimestamp(data.fecha),
    concepto: data.concepto || "",
    cliente: data.cliente || "",
    colega: data.colega || "",
    categoria: data.categoria || "Otros",
    ingreso: Number(data.ingreso) || 0,
    aCuenta: Number(data.aCuenta) || 0,
    menos: Number(data.menos) || 0,
    total: Number(data.total) || 0,
    notas: data.notas || "",
    actualizadoEn: serverTimestamp(),
  };
  await updateDoc(ref, payload);
}

export async function eliminarIngreso(id) {
  await deleteDoc(doc(db, COL, id));
}